import axios from "axios";
import { BASE_URL } from '../../Utils/base_url';

const AfficheResaSite = async (idRestaurant) => {
    return await axios.get(`${BASE_URL}/api/restaurant/afficheReservationSite/${idRestaurant}`, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}


const DemandeConfirmation = async (data) => {
    return await axios.post(`${BASE_URL}/api/restaurant/demandeConfirmation`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}

const ChangeNombrePersonne = async (data) => {
    return await axios.post(`${BASE_URL}/api/restaurant/nombrePersonne`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}

const ChangeEtatResaDirect = async (data) => {
    return await axios.post(`${BASE_URL}/api/restaurant/changeEtatCreneau`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}


const ChangeResaDirect = async (data) => {
    return await axios.post(`${BASE_URL}/api/restaurant/changeReservationDirect`, data, {
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('tokenRestaurant'),
        }
    });
}



export { AfficheResaSite, DemandeConfirmation, ChangeNombrePersonne, ChangeEtatResaDirect, ChangeResaDirect }